import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于当事人与关系的高频疑问"
          desc="把最常被问到的几个问题集中回答，帮助你更快读懂人物背景与圈内关系。"
          align="center"
        />

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full cursor-pointer items-center gap-3 px-4 py-4 text-left md:px-5"
                >
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 font-label text-xs font-semibold text-primary-700">
                    {index + 1}
                  </span>
                  <h4 className="flex-1 font-heading text-sm font-semibold text-foreground-950 md:text-base">{item.q}</h4>
                  <i className={isOpen ? 'ri-subtract-line text-lg text-primary-600' : 'ri-add-line text-lg text-foreground-400'} />
                </button>
                {isOpen && (
                  <p className="px-4 pb-4 pl-[3.25rem] text-xs leading-relaxed text-foreground-600 md:px-5 md:pl-[3.75rem] md:text-sm">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}